import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {first} from "rxjs/operators";
import {AiAssistantService} from "../../../ai-assistant/service/ai-assistant.service";

@Component({
    selector: 'db-start-ai-website-building',
    templateUrl: './start-ai-website-building.component.html',
    styleUrls: ['./start-ai-website-building.component.scss'],
    standalone: false
})
export class StartAiWebsiteBuildingComponent implements OnInit {

  public loading: boolean;
  public isMobile: boolean;
  public companyTypes;
  public templates;
  public params: Record<string, string | number> = {};

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _aiAssistantService: AiAssistantService
  ) {
  }

  ngOnInit() {
    // Safety check: redirect guests without prefilledAiData
    const user = this._route.snapshot.parent?.parent?.data['user'];
    const queryParams: any = this._route.snapshot.queryParams;
    const hasPrefilledDataInStorage = !!localStorage.getItem('prefilledAiData');
    const hasPrefilledDataInQuery = !!queryParams.prefilledAiData;

    if (!user && !hasPrefilledDataInStorage && !hasPrefilledDataInQuery) {
      this._router.navigate(['/sign-up']);
      return;
    }
    const productId = parseInt(queryParams.plugin_id, 10);
    productId && localStorage.setItem('product_id', productId.toString());
    this.isMobile = window.innerWidth <= 991;
    this.companyTypes = this._route.snapshot.data['companyTypes'];
    !this.companyTypes &&  this.getCompanyTypes();
  }

  private getCompanyTypes(): void {
    this._aiAssistantService.getCategories()
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this.companyTypes = response.data.map(({name, title, keywords}) => (
            {label: title, value: title, keywords}
          ));
        }
      });

  }

}
